import axios from "axios";

export const keysToMap = (data, excludeKey) => {
  let dataAsArray = [];

  Object.keys(data).forEach(function(key) {
    if (key !== excludeKey) {
      dataAsArray.push(data[key]);
    }
  });

  return dataAsArray;
};

export const initConfig = setConfig => {
  axios
    .get("/assets/env.json")
    .then(result => {
      return setConfig(result.data);
    })
    .catch(error => {
    });
};

export function registerAxiosInterceptor() {
  axios.interceptors.response.use(
    function(response) {
      return response;
    },
    function(error) {
      return Promise.reject(error);
    }
  );
}

export const pushScreenChange = (navigate, route) => {
  navigate(route);
};
